import { createStyles, makeStyles, styled, Box, Backdrop } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const useStyles = makeStyles((theme) =>
  createStyles({
    carDialogStyle: {
      width: '95%',
      maxWidth: '600px',
    },
  }),
);

export const ModalContainer = styled(Box)(({ theme }) => ({
  // padding: '20px  0',
  overflow: 'hidden',
  backgroundColor: theme.palette.type === 'dark' ? COLORS.MODAL_DARK : COLORS.WHITE,
  border: theme.palette.type === 'dark' ? `1px solid ${COLORS.PRIMARY}` : `2px solid ${COLORS.PRIMARY}`,
  borderRadius: '8px',
}));

export const ModalHeaderContainer = styled(Box)(({ theme }) => ({
  padding: '10px 30px ',
}));

export const ModalContentContainer = styled(Box)(({ theme }) => ({
  padding: '20px',
}));

export const ModalAddFormContainer = styled(Box)(({ theme }) => ({
  marginTop: '10px',
}));

export const CustomBackDrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));
